import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../../../store'
import { ActivityOptions } from '../components/filter/Constants'
import { DateRangeSelectedItem } from '../api/types'

type ActivityFilter = {
  activityType: string
  dateRange: DateRangeSelectedItem
}
interface IActivitySliceState {
  activitiesFilter: ActivityFilter
}

const initialState: IActivitySliceState = {
  activitiesFilter: {
    activityType: ActivityOptions.map((x) => x.value).join(','),
    dateRange: {
      value: 'LAST10DAYS'
    }
  }
}

const Slice = createSlice({
  name: '@module/accounts/activities',
  initialState,
  reducers: {
    SetActivitiesFilter: (state, action: PayloadAction<ActivityFilter>) => {
      return { ...state, activitiesFilter: { ...action.payload } }
    },
    SetActivityType: (state, action: PayloadAction<string>) => {
      return { ...state, activitiesFilter: { ...state.activitiesFilter, activityType: action.payload } }
    }
  }
})

export const { SetActivitiesFilter, SetActivityType } = Slice.actions
export const getActivitiesFilterState = (state: RootState) => state.modules.accounts.activities.activitiesFilter
export default Slice.reducer
